import {useCallback, useState} from 'react';

export function useHover() {
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setIsHovering(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovering(false);
  }, []);

  return {
    isHovering,
    handleMouseEnter,
    handleMouseLeave,
  };
}
